import { OUTCOME_CATEGORY_PERFORMANCE_EXPECTATIONS } from 'global/constants';
import type { UpsertActivityOutcome } from '../../../../../../../gql/schema-types';
import { PerformanceExpectationGroup } from '../../activity-outcomes.constants';

/**
 * Build upsert payload for a single PE group. Sets parentOutcomeId on dimension
 * outcomes to the PE outcome id so the server can associate dimensions with their PE.
 * Question Types and CER are block-level, so they ride on the PE outcome only.
 */
function groupToOutcomes(
  group: PerformanceExpectationGroup
): UpsertActivityOutcome[] {
  const { outcomes: groupOutcomes, questionTypes, cerTypes } = group;
  const peOption =
    groupOutcomes[OUTCOME_CATEGORY_PERFORMANCE_EXPECTATIONS]?.[0];
  if (peOption?.value == null) return [];

  const outcomes: UpsertActivityOutcome[] = [];
  Object.keys(groupOutcomes).forEach(key => {
    const options = groupOutcomes[key] ?? [];
    options.forEach(option => {
      if (option?.value == null) return;
      const isPe = key === OUTCOME_CATEGORY_PERFORMANCE_EXPECTATIONS;
      outcomes.push({
        outcomeId: option.value,
        questionTypes: isPe ? questionTypes : [],
        proficiencies: [],
        cerTypes: isPe ? cerTypes : [],
        contentPointIds: [],
        ...(isPe ? {} : { parentOutcomeId: peOption.value }),
      });
    });
  });
  return outcomes;
}

export default groupToOutcomes;
